<template>
  <div class="border-b border-black py-4 text-left mb-4 md:flex">
    <div class="flex mr-auto">
      <div class="w-20 h-20 flex-none md:w-28 md:h-28 bg-gray-50 relative">
        <img
          v-if="item.image_path"
          :src="item.image_path"
          :alt="item.name"
          class="w-full h-full object-cover">
      </div>
      <div class="pl-4">
        <Link
          class="block"
          :href="route('product', { product: item.slug })">
          <h2 class="text-xl mb-0 md:text-2xl md:mb-1">{{ item.name }}</h2>
        </Link>
        <h3 class="text-lg text-gray-500 mb-3">
          <span class="mr-2">
            AN. {{ item.item_number }}<span v-if="item.best_before">, Verkaufstage: {{ item.best_before }}</span>
          </span>
          <span v-if="item.attachment_path">
            <a :href="item.attachment_path"
              class="inline-flex items-center text-accent-brown font-bold hover:text-black"
              target="_blank">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Steckbrief
            </a>
          </span>
        </h3>
        <svg v-if="item.bioland" class="w-9 h-9 mb-2 mr-2 sm:inline-block">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-bioland"></use>
        </svg>
        <span
          v-if="item.weekend_product"
          class="p-1 px-2 m-1 ml-0 bg-accent-green text-sm">
          Nur am Wochenende
        </span>
        <span
          v-if="item.weekday_availability_readable && item.weekday_availability_readable.length > 0"
          class="p-1 px-2 m-1 ml-0 bg-accent-green text-sm">
          {{ item.weekday_availability_readable }}
        </span>
        <span
          v-if="isSeasonal"
          class="p-1 px-2 m-1 ml-0 bg-accent-light-brown text-sm">
          vom <span class="font-bold">{{ orderableFrom }}</span> bis <span class="font-bold">{{ orderableTo }}</span>
        </span>
        <span
          v-if="isSeasonal && !item.orderable"
          class="p-1 px-2 m-1 ml-0 bg-accent-green text-sm">
          bald bestellbar
        </span>
      </div>
    </div>
    <div class="flex pt-4 md:pt-0 justify-end">
      <ProductQuantity
        class="ml-3 flex flex-col items-end"
        :item="item"
        :order="order"
        :saving="saving"
        :in-change-log="inChangeLog"
        @change-quantity="onAddProductToOrder" />
    </div>

    <modal
      :show="showUnusualQuantityModal"
      :closeable="true"
      @close="() => showUnusualQuantityModal = false">
      <div class="p-4">
        <h3
          class="text-xl font-bold mb-4">
          Unüblich Stückzahl
        </h3>
        <p>Die gewählte Stückzahl sieht unüblich aus. Soll diese beibehalten werden?</p>
        <div class="flex mt-4">
          <button
            class="mr-2 ml-auto text-black bg-white px-4 py-2 text-sm flex mt-2 transition-opacity border border-black hover:opacity-50"
            @click.prevent="() => {
              showUnusualQuantityModal = false
              quantity = null
            }">
            Stückzahl überarbeiten
          </button>
          <button
            class="button-primary"
            @click.prevent="() => {
              this.submitQuantityToOrder()
              this.showUnusualQuantityModal = false
            }">
            Ja, Stückzahl beibehalten
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import format from 'date-fns/format'
import { Link } from '@inertiajs/inertia-vue3'

import ProductQuantity from './Product/ProductQuantity'
import Modal from '@/Jetstream/Modal'
import numberRedundancyCheck from './Product/numberRedundancyCheck'

export default {
  name: 'Procuct',
  components: { Modal, Link, ProductQuantity },
  props: {
    item: {
      type: Object,
      required: true
    },
    order: {
      type: Object,
      required: false,
      default: null
    },
    saving: {
      type: Boolean,
      default: false
    },
    inChangeLog: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    quantity: null,
    showUnusualQuantityModal: false,
  }),

  computed: {
    isSeasonal() {
      return this.item.orderable_from ? true : false
    },

    orderableFrom() {
      if (!this.isSeasonal) {
        return null
      }

      return format(new Date(this.item.orderable_from), 'dd.LL.')
    },

    orderableTo() {
      if (!this.isSeasonal) {
        return null
      }

      return format(new Date(this.item.orderable_to), 'dd.LL.')
    },
  },

  methods: {
    onAddProductToOrder(quantity) {
      const atypicalQuantity = this.item.primary_category ? this.item.primary_category.atypical_quantity : null
      this.quantity = quantity

      if (
          (atypicalQuantity !== null && quantity > atypicalQuantity)
        || numberRedundancyCheck(quantity))
      {
        this.showUnusualQuantityModal = true
      } else {
        this.submitQuantityToOrder()
      }
    },

    quantityTypingError() {
      return false
    },

    submitQuantityToOrder () {
      this.$emit('submit', {
        item: this.item,
        quantity: this.quantity,
      })

      this.quantity = null
      this.showUnusualQuantityModal = false
    }
  }
}
</script>
